export class StonlyEventsListProvider {
  static list: string[] = [
    'stonly-widget-opened',
    'stonly-widget-closed',
    'stonly-guide-viewed',
    'stonly-guide-completed',
    'stonly-search-performed',
    'stonly-article-viewed',
    'stonly-feedback-submitted'
  ];
}

